import type { ParsedQueryParams } from '~/providers/query-params/types';
import { store } from '~/utils/store';

/**
 * Prefer Demo Tools selection (`PERCH_PROGRAM_ID` store), then URL `programId` (parsed or unparsed).
 */
export function resolvePerchProgramId(queryParams?: ParsedQueryParams): string | undefined {
  const fromStore = store.get('PERCH_PROGRAM_ID');
  if (typeof fromStore === 'string' && fromStore.trim() !== '') {
    return fromStore.trim();
  }
  const fromParams = queryParams?.programId ?? queryParams?.unparsedQueryParams?.programId;
  if (typeof fromParams === 'string' && fromParams.trim() !== '') {
    return fromParams.trim();
  }
  return undefined;
}
